module.exports = __webpack_public_path__ + "img/level-3.40f0bb64.png";